import React, { useCallback, useMemo, useState } from "react";
import { useDropzone } from "react-dropzone";
import {
  acceptStyle,
  baseStyle,
  focusedStyle,
  rejectStyle,
} from "./uploadCustomWatchListsStyles.js";
import { MAX_FILE_SIZE } from "../../../features/score-card/constants/formValidations.js";
import "./uploadCustomWatchLists.css";
import { UploadFile } from "../../../assets/index.js";

const UploadCustomWatchLists = ({ field, form, accept }) => {
  const [errorMessage, setErrorMessage] = useState(null);
  const clearError = () => setErrorMessage(null);

  const onDropRejected = (files) => {
    try {
      if (files) {
        const error = files[0].errors[0];
        setErrorMessage(error.code);
      }
    } catch (error) {
      console.error("something went wrong with file uploading/selecting");
    }
  };

  const onError = (error) => {};
  const onDrop = useCallback(
    (acceptedFiles) => {
      const acceptedFile = acceptedFiles[0];
      form.setFieldValue(field.name, acceptedFile);
    },
    [form]
  );

  const { getRootProps, getInputProps, isFocused, isDragAccept, isDragReject } =
    useDropzone({
      onDrop,
      multiple: false,
      accept,
      maxSize: MAX_FILE_SIZE,
      onError,
      onDropRejected: onDropRejected,
      onDropAccepted: clearError,
    });

  const style = useMemo(
    () => ({
      ...baseStyle,
      ...(isFocused ? focusedStyle : {}),
      ...(isDragAccept ? acceptStyle : {}),
      ...(isDragReject ? rejectStyle : {}),
    }),
    [isFocused, isDragAccept, isDragReject]
  );

  return (
    <div className="upload-custom-watch-lists-uploader-container">
      <div className="upload-custom-watch-lists-button-box">
        <div className="upload-custom-watch-lists-label">Choose file to upload</div>
        <div className="upload-custom-watch-lists-choose-button" {...getRootProps()}>
          Browse Files
        </div>
      </div>
      <div {...getRootProps({ style })}>
        <input {...getInputProps()} />

        <div className="d-flex flex-column ">
          <UploadFile />
          <p className="drag-label">
            {field.value ? (
              <span>{field.value.name}</span>
            ) : (
              "Drag and drop files here"
            )}
          </p>
        </div>
      </div>
      <span className="red">{errorMessage}</span>
    </div>
  );
};

export default UploadCustomWatchLists;



// WEBPACK FOOTER //
// ./src/components/formik/uploadCustomWatchLists/UploadCustomWatchLists.jsx